import { AxiosInstanceFunc, HZAxiosInstanceFunc } from '@hz-insights/web-components'
import { ticketConfig } from 'utils/synchronizeTicket'
import { installChartLangInterceptor } from 'utils/chartLang'

installChartLangInterceptor()

ticketConfig.synchronizeCookie2LocalStorage()

// 本地开发免登录: 注入预置 token(仅 development, 生产无此行为); 须在 cookie 同步之后执行, 否则会被清除。
// 注意是覆盖写入: 浏览器里若残留旧 token(过期或属于其他账号)会导致所有图表"没有权限",
// 本地测试环境必须保证身份一致。
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_TOKEN) {
  const devToken = process.env.REACT_APP_DEV_TOKEN
  localStorage.setItem('token', devToken)
  AxiosInstanceFunc.defaults.headers.common['Authorization'] = `bearer ${devToken}`
  HZAxiosInstanceFunc.defaults.headers.common['Authorization'] = `bearer ${devToken}`
}
